<template>
  <v-container class="pa-1" grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <v-container class="pa-1" v-if="lAction === 'view'">
          <v-layout>
            <v-flex xs12 mx-auto>
              <!-- list of recent manual journal entries -->
              <v-card>
                <v-card-title class="pa-2 grey lighten-4">
                  <div class="title grey--text">Recent Journal Entries</div>
                </v-card-title>
                <v-card-text class="pa-0">
                  <v-data-table
                  :headers="journalHead"
                  :items="journalList"
                  hide-actions
                  class="elevation-0"
                  disable-initial-sort
                  >
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td>{{ props.item.trans_desc }}</td>
                      <td>{{ handy.formatDate(props.item.trans_dt) }}</td>
                      <td>{{ props.item.gl_acc_name }}</td>
                      <td>{{ props.item.debit_amount }}</td>
                      <td>{{ props.item.credit_amount }}</td>
                      <td><v-btn icon small @click="deleteJournalTrans(props.item)"><v-icon small>delete</v-icon></v-btn></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>

            <v-btn
            :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; right:15px;':'bottom:15px; right:15px;')"
            dark fab fixed
            color="accent"
            @click.native="prepareCreate()"
            >
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- create / update account details -->
    <v-container v-if="lAction === 'create'" class="pa-0">
      <v-layout row wrap>
        <v-flex xs12>
          <v-form ref="lForm" @submit.prevent="saveChanges(lAction)">
            <v-card flat>
              <v-flex xs12 sm9 mx-auto>
                <v-card-text class="pt-1 pb-0">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-text-field
                      label="Description"
                      v-model="lJournal.trans_desc"
                      :rules="[rules.required]"
                      hint="The narration of this journal entry"
                      persistent-hint
                      maxlength="150"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-dialog ref="dlgJournalDt"
                      persistent v-model="dtDlg"
                      lazy full-width width="290px"
                      :return-value.sync="lJournal.trans_dt"
                      >
                      <v-text-field
                      slot="activator" label="Date"
                      v-model="lJournal.trans_dt" append-icon="event"
                      readonly
                      :rules="[rules.required]"></v-text-field>
                      <v-date-picker v-model="lJournal.trans_dt"
                      first-day-of-week="1" :max="today">
                      <v-spacer></v-spacer>
                      <v-btn flat @click="dtDlg = false">Cancel</v-btn>
                      <v-btn flat color="accent" @click="$refs.dlgJournalDt.save(lJournal.trans_dt)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  label="Amount"
                  v-model="lJournal.trans_amount"
                  :rules="[rules.required]"
                  type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-combobox
                  v-model="lJournal.debit_gl_pair"
                  label="Debit Account"
                  :items= "accHeads"
                  item-value="gl_acc_id"
                  item-text="gl_acc_name"
                  :rules="[rules.required]"
                  clearable
                  ></v-combobox>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-combobox
                  v-model="lJournal.credit_gl_pair"
                  label="Credit Account"
                  :items= "accHeads"
                  item-value="gl_acc_id"
                  item-text="gl_acc_name"
                  :rules="[rules.required]"
                  clearable
                  ></v-combobox>
                </v-flex>
                <v-flex xs12>
                  <v-alert class="pa-2" value="true" outline color="info">HINT:<br />
                    <ul>
                      <li>
                        Income Adj. - Choose <span class="accent--text">bank/cash</span> as debit account and <span class="accent--text">unit no.</span> from whom money is received as credit account
                      </li>
                      <li>
                        Expense Adj. - Choose <span class="accent--text">vendor</span> who receives money as debit account and <span class="accent--text">bank/cash</span> as credit
                      </li>
                      <li>
                        Write-off Balance - Choose <span class="accent--text">Bad Debts or Round off</span> as debit account and <span class="accent--text">unit no.</span> as credit account
                      </li>
                    </ul>
                  </v-alert>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click.native="cancelChanges">Cancel</v-btn>
              <v-btn type="submit" :disabled="beingSaved" color="accent">Save</v-btn>
            </v-card-actions>
          </v-flex>
        </v-card>
      </v-form>
    </v-flex>
  </v-layout>
</v-container>

<!-- common elements for alert & loading spinner -->
<v-snackbar :color="sbarCol" v-model="sbar" :timeout="2000" multi-line>
  <span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>

</v-flex>
</v-layout>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'

export default {
  data () {
    return {
      // common
      lAction: '',
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      handy: handy,
      config: config,
      rules: handy.rules,
      beingSaved: false,
      dtDlg: false,

      // screen specific
      lJournal: '',
      accHeads: [],
      journalList: [],
      journalHead: [
        { text: 'Description', value: 'trans_desc' },
        { text: 'Date', value: 'trans_dt' },
        { text: 'Account', value: 'gl_acc_name' },
        { text: 'Debit', value: 'debit_amount' },
        { text: 'Credit', value: 'credit_amount' },
        { text: 'Action', value: '', width: '100px' }
      ]
    }
  }, // data
  computed: {
    today: function () {
      return handy.formatDBDate(Date())
    }
  },
  created () {
    this.loadRecJournal()
    this.loadAccHeads()
    this.lAction = 'view'
  },
  methods: {
    // common methods
    msg (m, isError = false) {
      this.sbarCol = isError ? 'error' : 'success'
      this.sbar = true
      this.sbarMsg = m
    },
    // screen specific methods
    loadRecJournal () {
      // existing accounts
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getRecentJournals/', qry)
      .then(response => {
        this.journalList = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.journalList = []
      })
    },
    loadAccHeads () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getAccountHeadsLiteByCommId/', qry)
      .then(response => {
        this.accHeads = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.accHeads = []
      })
    },
    prepareCreate () {
      this.lJournal = this.getEmptyJournal()
      this.lAction = 'create'
    },
    getEmptyJournal () {
      var emptyJournal = {
        comm_id: config.COMM_ID,
        trans_dt: '',
        trans_desc: '',
        trans_amount: '',
        debit_gl_pair: '',
        credit_gl_pair: ''
      }
      return emptyJournal
    },
    saveChanges () {
      if (!this.$refs.lForm.validate()) {
        return
      }
      if (!this.lJournal.debit_gl_pair || !this.lJournal.debit_gl_pair.gl_acc_id) {
        this.msg('Please choose debit account', true)
        return
      }
      if (!this.lJournal.credit_gl_pair || !this.lJournal.credit_gl_pair.gl_acc_id) {
        this.msg('Please choose credit account', true)
        return
      }
      this.beingSaved = true
      // pre-req
      this.lJournal.debit_gl_acc_id = this.lJournal.debit_gl_pair.gl_acc_id
      this.lJournal.debit_gl_acc_type = this.lJournal.debit_gl_pair.gl_acc_type
      this.lJournal.credit_gl_acc_id = this.lJournal.credit_gl_pair.gl_acc_id
      this.lJournal.credit_gl_acc_type = this.lJournal.credit_gl_pair.gl_acc_type

      this.axios.post(config.API_URL + '/journal/create', this.lJournal)
      .then(response => {
        // update the frontend
        this.loadRecJournal()
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.beingSaved = false
      })
    },
    cancelChanges () {
      this.lAction = 'view'
    },
    deleteJournalTrans (curJournal) {
      // confirm
      if (confirm('Sure, you want to delete the journal transaction of account "' + curJournal.gl_acc_name + '"?\n' +
      'IMPORTANT: Ensure deleting the pair of this transaction as well')) {
        // delete
        this.axios.post(config.API_URL + '/journal/delete', curJournal)
        .then(response => {
          // update the frontend
          this.loadRecJournal()
          this.lAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data, true)
          this.beingSaved = false
        })
      }
    }
  } // methods
} // export
</script>



// WEBPACK FOOTER //
// Journal.vue?f117bda0